import {isNil} from 'ramda';
import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {
  initPartnerDepotObject,
  initPartnerObject,
  partnersInitialState
} from './data';
import {Partner} from './types';

const partnersSlice = createSlice({
  name: 'partners',
  initialState: partnersInitialState,
  reducers: {
    partnersFetchStarted: state => {
      state.partnersLoading = true;
    },
    partnersFetchSucceeded: (state, {payload}: PayloadAction<Partner[]>) => {
      state.list = payload;
      state.partnersLoading = false;
    },
    partnersFetchFailed: state => {
      state.list = [];
      state.partnersLoading = false;
    },
    setPartner: (state, {payload}: PayloadAction<any | null>) => {
      return {
        ...state,
        partner: isNil(payload) ? initPartnerObject : payload
      };
    },
    resetPartner: state => {
      return {...state, partner: null};
    },
    addToPartners: (state, {payload}: PayloadAction<any>) => {
      return {...state, list: [...(state.list ?? []), payload]};
    },
    updatePartners: (state, {payload}: PayloadAction<any>) => {
      const list = [...(state.list ?? [])].map(partner => {
        return payload.id === partner.id ? payload : partner;
      });

      return {...state, list};
    },
    deleteFromPartners: (state, {payload}: PayloadAction<any>) => {
      const list = [...(state.list ?? [])].filter(
        partner => payload.id !== partner.id
      );

      return {...state, list};
    },
    addPartnerDepot: state => {
      const depots = [...state.partner.depots, initPartnerDepotObject];

      return {
        ...state,
        partner: {
          ...state.partner,
          depots
        }
      };
    },
    deletePartnerDepot: (state, {payload}: PayloadAction<any>) => {
      const depots = [...state.partner.depots].filter(
        (_, index) => index !== payload
      );

      return {
        ...state,
        partner: {
          ...state.partner,
          depots
        }
      };
    },
    updatePartnerDepot: {
      reducer(state, {payload}: PayloadAction<{index: number; depot: any}>) {
        const depots = [...state.partner.depots].map((depot, index) =>
          index === payload.index ? payload.depot : depot
        );

        return {
          ...state,
          partner: {
            ...state.partner,
            depots
          }
        };
      },
      prepare(index: number, depot: any) {
        return {
          payload: {index, depot}
        };
      }
    }
  }
});

export const {
  partnersFetchStarted,
  partnersFetchSucceeded,
  partnersFetchFailed,
  setPartner,
  resetPartner,
  addToPartners,
  updatePartners,
  deleteFromPartners,
  addPartnerDepot,
  deletePartnerDepot,
  updatePartnerDepot
} = partnersSlice.actions;

export default partnersSlice.reducer;
